module.exports = __webpack_public_path__ + "static/media/top-nfts-1.9a27af86.jpg";